export default {"src":"/_next/static/media/logo-azul.11a36f57.svg","height":28,"width":180};